import { connect } from 'react-redux'
import { compose, branch, mapProps, renderNothing } from 'recompose'

import { readOnlySelector } from 'containers/Project/View/selectors'
import { rolesSelector } from 'containers/Role/selectors'

const mapStateToProps = (state) => {
  return {
    readOnly: readOnlySelector(state),
    ownRoles: rolesSelector(state)
  }
}

const withProjectProps = connect(mapStateToProps)

const withHideOnReadOnly = branch(
    ({ readOnly }) => readOnly,
    renderNothing
  )

const hideOnReadOnly = compose(
  withProjectProps,
  withHideOnReadOnly
)

const withHideOnReadOnlyOnRole = branch(
  ({ readOnly, ownRoles, role }) => readOnly && ownRoles && ownRoles.includes(role),
  renderNothing
)

const hideOnReadOnlyOnRole = compose(
  withProjectProps,
  withHideOnReadOnlyOnRole
)

export {
  hideOnReadOnly,
  hideOnReadOnlyOnRole // temperarory for cpm only
}
